import o from "./ghl-ui.es677.js";
import e from "./ghl-ui.es687.js";
import i from "./ghl-ui.es688.js";
function n(t, r) {
  return i(e(t, r, o), t + "");
}
export {
  n as default
};
